import type { CustomTheme } from '../../types/custom-theme';
import type { Product } from '../../types/product';

const baseButtonSize: CustomTheme.VariantCSSKeys<ButtonSizeVariantsType> = {
  small: {
    padding: '8px 16px',
  },
  medium: {
    padding: '12px 24px',
  },
  large: {
    padding: '16px 32px',
  },
};

const buttonSize: Product.VariantKeyModes<ButtonSizeVariantsType> = {
  products: {
    chart: baseButtonSize,
    chartblog: baseButtonSize,
    co: baseButtonSize,
    edu: baseButtonSize,
    scale: baseButtonSize,
    spark: baseButtonSize,
  },
};

export type ButtonSizeVariantsType = 'small' | 'medium' | 'large';
export const buttonSizeVariants = Object.keys(baseButtonSize) as ButtonSizeVariantsType[];

export default buttonSize;
